module.exports = __webpack_public_path__ + "static/media/img_name_plusx.1caf17cc.png";